import styled from "styled-components";
import { Typography, Fab, Grid } from "@material-ui/core";
import theme from "@src/Tools/MuiTheme";

export const STGrid = styled(Grid)`
  && {
    overflow-y: scroll;
    min-height: calc(80vh - 180px);
    max-height: calc(90vh - 180px);
    margin-top: 8px;
    margin-bottom: 16px;
  }
`;

export const STLocationGrid = styled(Grid)`
  && {
    padding-bottom: 14px;
  }
`;

export const STRemoveGrid = styled(Grid)`
  && {
    display: flex;
    justify-content: flex-end;
  }
`;

export const STPositionsTypography = styled(Typography)`
  && {
    font-size: 16px;
    font-weight: bold;
    margin: ${theme.spacing(1)}px;
    text-align: center;
  }
`;

export const STForm = styled.form`
  width: 500px;
`;

export const CSButtonWrapper = styled.div``;

export const STTypography = styled(Typography)`
  && {
    width: 100%;
    word-wrap: break-word;
    height: auto;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    width: 6vw;
    max-width: 110px;
    font-size: 0.875rem;
  }
`;

export const CSFab = styled(Fab)`
  && {
    margin: 6px;
    transform: scale(0.8);
  }
`;
